import { createAction } from '../../../core/helpers'

import { FETCH_SOPS } from '../action-types'

const cleanupFetchSops = createAction(FETCH_SOPS.CLEANUP)

export default cleanupFetchSops
